<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <b-form @submit.stop.prevent="handleSubmit(importarXml)">
      <b-card class="m-3">
        <template #header>
          <h6 class="mb-0 text-center">
            <span class="titulo-sagres font-weight-bold">Importar aditivos de contrato</span>
            <btn-voltar />
            <b-button class="float-right m-1" size="sm" type="submit">
              <font-awesome-icon icon="file-upload" />
              Enviar
            </b-button>
          </h6>
        </template>

        <b-row>
          <b-col>
            <div id="fileInputWrapper" class="d-flex align-items-center">
              <validation-provider rules="required" v-slot="validationContext" name="arquivo">
                <b-form-group class="mb-5" id="arquivo-input-group" label="Arquivo (.zip)*" label-for="input-arquivo"
                  label-cols="auto" content-cols="12">
                  <b-form-file v-model="arquivo" :state="getValidationState(validationContext)"
                    placeholder="Escolha um arquivo..." drop-placeholder="Solte o arquivo aqui..."
                    browse-text="Escolher" accept=".zip" @change="temAditivosNaoImportados = false"></b-form-file>
                  <b-form-invalid-feedback id="input-arquivo-live-feedback">{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <btn-download class="ml-3" v-if="temAditivosNaoImportados"
                :fazerDownload="baixarRelatorioDeInconsistencias" :texto="'Relatório de inconsistências'" />
            </div>
          </b-col>
        </b-row>
        <div v-if="temAditivosNaoImportados" class="aditivosNaoImportadosWrapper">
          <div v-if="items.length > 0">
            <span class="mt-3"><b>Aditivos não Importados</b></span>
            <b-table class="mt-3" :fields="fields" striped hover no-border-collapse :items="items" small>
            </b-table>
            <table-pagination :total-rows="items.length" :per-page="perPage" @pageChange="pageChange">
            </table-pagination>
          </div>
        </div>
      </b-card>
    </b-form>
  </validation-observer>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import aditivosContratoService from '@/services/licitacoes/aditivosContratoService';
import TablePagination from '@/components/atos-pessoal/TablePagination.vue';
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import BtnDownload from '@/components/shared/btn-download.vue'
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';

const CompProps = Vue.extend({
  name: "ImportarXmlAditivoContrato",
  components: {
    ValidationProvider,
    ValidationObserver,
    TablePagination,
    BtnVoltar,
    BtnDownload
  }
})

@Component
export default class ImportarXmlAditivoContrato extends mixins(UtilsTS, CompProps) {
  arquivo: any = null
  temAditivosNaoImportados = false
  errosValidacao: any[] = []
  perPage = 10
  currentPage = 1
  items: any[] = []
  fields = [
    {
      key: "nrAnoAditivo",
      label: "Nº/Ano Aditivo",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "nrAnoContrato",
      label: "Nº/Ano Contrato",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "naturezaAjuste",
      label: "Natureza do Ajuste",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "justificativa",
      label: "Justificativa",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "valor",
      label: "Valor",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "dtInicioVigencia",
      label: "Início Vigência",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "dtFimVigencia",
      label: "Fim Vigência",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "dtAssinatura",
      label: "Data de Assinatura",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
  ]

  voltar() {
    this.$router.go(-1);
  }

  async importarXml() {
    this.items = [];
    this.temAditivosNaoImportados = false;
    const response = await aditivosContratoService.importarXml(this.arquivo);
    if (response && response.status == 200) {
      //mostrar mensagem de sucesso
      this.$toast.success('Arquivo importado com sucesso');
      this.$router.push('/modulo-licitacoes/aditivos-contratos');
    }
    else {
      if (response && response.data.aditivosNaoImportados) this.items = response.data.aditivosNaoImportados;
      this.temAditivosNaoImportados = true;
      if (response) this.errosValidacao = response.data;
      this.$toast.error('Erro ao processar o arquivo enviado');
    }
    //this.$refs.observer.reset();
    this.arquivo = null;
  }

  async baixarRelatorioDeInconsistencias() {
    //console.log("errosValidacao", this.errosValidacao)
    const response = await aditivosContratoService.baixarRelatorioDeInconsistencias(this.errosValidacao);
    if (response && response.status == 200)
      this.download("relatorio-de-inconsistencias-aditivos-contrato.pdf", response.data);
    else {
      this.$toast.error('Erro ao baixar o relatório de inconsistências');
    }
  }

  getValidationState({ dirty, validated, valid = null }) {
    return dirty || validated ? valid : null;
  }

  pageChange(value: number) {
    this.currentPage = value;
  }
};
</script>

<style>

</style>
